import * as Actions from 'store/actions/app/sale_retainers.actions'
import { addOrUpdateObjectInArray } from 'utils/add-or-update-object-in-array'
import { toggleIdInArray } from 'utils/toggle-id-in-array'

const initialState = {
  loading_sale_retainers: false,
  sale_retainers: [],
  total_sale_retainers: 0,

  loading_sale_retainer: false,
  sale_retainer: null,

  loading_sale_retainers_for_invoice_by_person: false,
  sale_retainers_for_invoice_by_person: [],

  saving_sale_retainer: false,
  saved_sale_retainer: false,
  saved_sale_retainer_data: null,

  voiding_sale_retainer_ids: [],
  voided_sale_retainer_ids: [],
}

export default function saleRetainersReducer(state = initialState, action) {
  switch (action.type) {
    case Actions.GET_SALE_RETAINERS: {
      return {
        ...state,
        loading_sale_retainers: action.payload.loading ?? state.loading_sale_retainers,
        sale_retainers: action.payload.items ?? state.sale_retainers,
        total_sale_retainers: action.payload.total ?? state.total_sale_retainers,
      }
    }
    case Actions.GET_SALE_RETAINER_BY_ID: {
      return {
        ...state,
        loading_sale_retainer: action.payload.loading ?? state.loading_sale_retainer,
        sale_retainer: action.payload.data ?? state.sale_retainer,
      }
    }
    case Actions.GET_SALE_RETAINERS_FOR_INVOICE_BY_PERSON_ID: {
      return {
        ...state,
        loading_sale_retainers_for_invoice_by_person: action.payload.loading ?? state.loading_sale_retainers_for_invoice_by_person,
        sale_retainers_for_invoice_by_person: action.payload.data ?? state.sale_retainers_for_invoice_by_person,
      }
    }
    case Actions.RESET_SALE_RETAINERS_FOR_INVOICE_BY_PERSON_ID: {
      return {
        ...state,
        sale_retainers_for_invoice_by_person: [],
      }
    }
    case Actions.SAVE_SALE_RETAINER: {
      return {
        ...state,
        saving_sale_retainer: action.payload.saving ?? state.saving_sale_retainer,
        saved_sale_retainer: action.payload.saved ?? false,
        saved_sale_retainer_data: action.payload.data ?? null,
        sale_retainers: action.payload.data
          ? addOrUpdateObjectInArray(state.sale_retainers, action.payload.data, 'anticipo_venta_id', true)
          : state.sale_retainers,
      }
    }
    case Actions.VOID_SALE_RETAINER: {
      return {
        ...state,
        voiding_sale_retainer_ids: toggleIdInArray(state.voiding_sale_retainer_ids, action.payload.voiding_id),
        voided_sale_retainer_ids: toggleIdInArray(state.voided_sale_retainer_ids, action.payload.voided_id),
        sale_retainers: state.sale_retainers.filter(item => item.anticipo_venta_id !== action.payload.voided_id)
      }
    }
    default: {
      return state
    }
  }
}
